/**
 * v3 mobile filter drawer — in-place accordions instead of Dawn's sliding submenus.
 *
 * MenuDrawer (global.js) binds a click handler to every <summary> inside
 * <menu-drawer>. For anything other than the drawer's own summary it opens a
 * submenu: it adds `menu-opening`, marks the panel `submenu-open` (which hides
 * the rest of the list) and traps focus inside the revealed element — all wrong
 * for an accordion that expands in place. Stopping the click during the capture
 * phase keeps it from reaching those listeners; the <details> element's native
 * toggle is a default action, so it still runs.
 */
document.addEventListener(
  'click',
  (event) => {
    const target = event.target;
    if (target instanceof Element && target.closest('.ccpv3-facets__summary')) {
      event.stopPropagation();
    }
  },
  true
);
